import Route from 'cio/routes/base';

export default class BroadcastsRoute extends Route {
  crumb() {
    return {
      name: 'Broadcasts',
      path: 'broadcasts',
      helpLabel: 'broadcasts',
      helpUrl: 'https://customer.io/docs/journeys/broadcasts-in-customerio/',
    };
  }
}
